<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="ListsOverview")
    h1.title Endreinigungsliste
    .sub-headline Hier können Sie sich eine Endreinigungsliste generieren lassen.
    
    .calendar-config.margin-top      
      v-date-picker(is-expanded :columns="4" is-range v-model="dateRange")

    .button-wrapper.margin-top.right   
      //- b-button(type="is-light" icon-left="cog" @click="" disabled) Konfiguration
      b-button(type="is-light" icon-left="file-excel" @click="createExcel()") Endreinigungs-Excel herunterladen

    .card.margin-top
      .main
        b-table(:data="cleaningDates"
                default-sort-direction="asc"
                hoverable)
          b-table-column(label='Nr.' v-slot="props")
            | {{props.index + 1}}
          b-table-column(field='isChange' label='Wechsel' v-slot="props")
            b {{props.row.isChange ? 'W' : ''}}
          b-table-column(field='endDate' label='Abreise' sortable v-slot="props" width="120")
            | {{formatDate(props.row.endDate)}}
          b-table-column(field='rentObject.code' label='Code' sortable v-slot="props")
            a(@click="jumpToBooking(props.row)") {{props.row.rentObject.code}}
          b-table-column(field='rentObject.rooms' label='Zimmer' sortable v-slot="props")
            | {{props.row.rentObject.rooms}}
          b-table-column(label='BW' v-slot="props")
            | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Bettwäsche')}}
          b-table-column(label='HT' v-slot="props")
            | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Handtuchset')}}
          b-table-column(label='KB' v-slot="props")
            | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Kinderreisebett')}}
          b-table-column(label='KH' v-slot="props")
            | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Kinderhochstuhl')}}
          b-table-column(label='Tier' v-slot="props")
            | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Haustier')}}
          b-table-column(field='nextBooking.startDate' label='Nächste Anreise' sortable v-slot="props" width="120")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{formatDate(props.row.nextBooking[0].startDate)}}
              //- pre {{props.row.nextBooking[0].bookingItems}}
            div(v-else) -
          b-table-column(label='BW' v-slot="props")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{getCountFromBookingExtraCode(props.row.nextBooking[0].bookingItems, 'Bettwäsche')}}
            div(v-else) -
          b-table-column(label='HT' v-slot="props")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{getCountFromBookingExtraCode(props.row.nextBooking[0].bookingItems, 'Handtuchset')}}
            div(v-else) -
          b-table-column(label='KB' v-slot="props")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{getCountFromBookingExtraCode(props.row.nextBooking[0].bookingItems, 'Kinderreisebett')}}
            div(v-else) -
          b-table-column(label='KH' v-slot="props")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{getCountFromBookingExtraCode(props.row.nextBooking[0].bookingItems, 'Kinderhochstuhl')}}
            div(v-else) -
          b-table-column(label='Reinigungsinformation' v-slot="props")
            .edit-text(@click="selectedBooking = props.row; isCleaningInformationModalActive = true")
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom')
                b-button(v-if="!props.row.cleaningInformation" icon-left="plus")
                div(v-else) {{props.row.cleaningInformation}}
          //- b-table-column(label='Tier' v-slot="props")
            div(v-if="props.row.nextBooking && props.row.nextBooking[0]") {{getCountFromBookingExtraCode(props.row.nextBooking[0].bookingItems, 'Haustier')}}
            div(v-else) -

  b-modal(v-model='isCleaningInformationModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6 An- und Abreise Informationen aktualisieren
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Informationen",
              rules="",
              v-slot="{ errors, valid }")
              b-field(
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors")
                b-input(type="textarea" v-model="selectedBooking.cleaningInformation" maxlength="1000")
            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="isCleaningInformationModalActive = false"
              ) Abbrechen
              b-button(
                type="is-primary",
                @click="handleSubmit(updateBooking)"
              ) Aktualisieren

</template>

<script>
import { DateTime } from 'luxon';
import * as ExcelJS from 'exceljs';

export default {
  data() {
    return {
      isCleaningInformationModalActive: false,
      selectedBooking: null,
      cleaningDates: [],
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      settings: {},
      weekdays: [
        "-",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
        "Sonntag"
      ]
    };
  },
  watch: {
    dateRange: {
      async handler(){
        const loadingComponent = this.$buefy.loading.open();
        this.cleaningDates = await this.$store.dispatch("rentObjectBookings/findCleaningDates", this.dateRange);
        // this.sortDates();
        loadingComponent.close();
      },
      deep: true
    }
  },
  async mounted() {
    this.cleaningDates = await this.$store.dispatch("rentObjectBookings/findCleaningDates", this.dateRange);
    this.settings = await this.$store.dispatch("settings/find");
  },
  computed: {
    uniqueCleaningDates() {
      const uniqueCleaningDates = {};
      for (let i = 0; i < this.cleaningDates.length; i += 1) {
        if (!uniqueCleaningDates[this.formatDate(this.cleaningDates[i].endDate)]) {
          uniqueCleaningDates[this.formatDate(this.cleaningDates[i].endDate)] = [];
          uniqueCleaningDates[this.formatDate(this.cleaningDates[i].endDate)].push(this.cleaningDates[i]);
        } else {
          uniqueCleaningDates[this.formatDate(this.cleaningDates[i].endDate)].push(this.cleaningDates[i]);
        }
      }
      return uniqueCleaningDates;
    }
  },
  methods: {
    jumpToBooking(booking) {
      this.$router.push({name: 'Booking', params: {id: booking.id}});
    },
    async updateBooking() {
      await this.$store.dispatch("rentObjectBookings/updateData", this.selectedBooking);
      this.departures = await this.$store.dispatch("rentObjectBookings/findCleaningDates", this.dateRange);
      this.isCleaningInformationModalActive = false;
    },
    sortDates() {
      this.cleaningDates.sort(function(a, b) {
        var nameA = a.rentObject.code.replace("/", "").toUpperCase(); // Groß-/Kleinschreibung ignorieren
        var nameB = b.rentObject.code.replace("/", "").toUpperCase(); // Groß-/Kleinschreibung ignorieren
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // Namen müssen gleich sein
        return 0;
      });

      this.cleaningDates.sort(function(a, b) {
        var dateA = new Date(a.endDate); // Groß-/Kleinschreibung ignorieren
        var dateB = new Date(b.endDate); // Groß-/Kleinschreibung ignorieren
        if (dateA < dateB) {
          return -1;
        }
        if (dateA > dateB) {
          return 1;
        }

        // Namen müssen gleich sein
        return 0;
      });
    },
    formatDate(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.yy")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    prettyFormatDate(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("ccc. dd.LL.yy")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("ccc. dd.LL.yy")
    },
    formatDateTime(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.yyyy HH:mm")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy HH:mm")
    },
    getCountFromBookingExtraCode(items, code) {
      const item = items.find(i => i.name === code);
      if (item) return item.count;
      return ''
    },
    matchesHoliday(isoDate, holidays) {
      return holidays.find(h => DateTime.fromISO(h.date).toISODate() === isoDate);
    },
    async createExcel() {
      const holidays = await this.$store.dispatch('holidays/findBetweenRange', {startDate: this.dateRange.start, endDate: this.dateRange.end})
      const wb = new ExcelJS.Workbook();

      let rootWs =  wb.addWorksheet('Alle Reinigungen', {
        pageSetup:{
          paperSize: 9,
          orientation:'landscape',
          horizontalCentered: true,
          margins: {
            left: 0.2, right: 0.2,
            top: 0.2, bottom: 0.2,
            header: 0.1, footer: 0.1
          }
        }
      });

      this.generateWorksheet(rootWs, this.cleaningDates, `| ${this.prettyFormatDate(this.dateRange.start)}` + ((this.dateRange.end && this.prettyFormatDate(this.dateRange.start) !== this.prettyFormatDate(this.dateRange.end)) ? ` - ${this.prettyFormatDate(this.dateRange.end)}` : ''));

      for (const [key, values] of Object.entries(this.uniqueCleaningDates)) {
        let ws =  wb.addWorksheet(`${this.weekdays[DateTime.fromFormat(key, 'dd.LL.yy').weekday]}, ${key}`, {
          pageSetup:{
            paperSize: 9,
            orientation:'landscape',
            horizontalCentered: true,
            margins: {
              left: 0.2, right: 0.2,
              top: 0.2, bottom: 0.2,
              header: 0.1, footer: 0.1
            }
          },
          properties:{tabColor: DateTime.fromFormat(key, 'dd.LL.yy').weekday === 7 || this.matchesHoliday(DateTime.fromFormat(key, 'dd.LL.yy').toISODate(), holidays) ? { argb:'FFFF1493' } : undefined}
        });
        this.generateWorksheet(ws, values, key);
      }

      const self = this;
      wb.xlsx.writeBuffer( {
          base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          const start = DateTime.fromJSDate(self.dateRange.start);
          const end = DateTime.fromJSDate(self.dateRange.end);
          a.download = `ER_${start.toFormat("dd_LL_yy")}-${end.toFormat("dd_LL_yy")}.xlsx`;
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    generateWorksheet(ws, values, name) {
      const fontOptions = {
         name: 'Arial',
         size: 12,
      };
      const columns = [
        { header: 'Nr', key: 'nr', width: 5, style: { font: fontOptions}},
        { header: 'W', key: 'isChange', width: 5, style: { font: fontOptions}},
        { header: 'Abreise', key: 'endDate', width: 12, style: { font: fontOptions}},
        { header: 'Code', key: 'code', style: { font: fontOptions}},
        { header: 'Zi', key: 'rooms', width: 10, style: { font: fontOptions}},
        { header: 'BW', key: 'bw', width: 4, style: { font: fontOptions}},
        { header: 'HT', key: 'ht', width: 4, style: { font: fontOptions}},
        { header: 'KB', key: 'kb', width: 4, style: { font: fontOptions}},
        { header: 'KH', key: 'kh', width: 4, style: { font: fontOptions}},
        { header: '🐶', key: 'tier', width: 5, style: { font: fontOptions}},
        { header: '', key: 'space', width: 1, style: { font: fontOptions}},
        { header: 'BW', key: 'newbw', width: 4, style: { font: fontOptions}},
        { header: 'HT', key: 'newht', width: 4, style: { font: fontOptions}},
        { header: 'KB', key: 'newkb', width: 4, style: { font: fontOptions}},
        { header: 'KH', key: 'newkh', width: 4, style: { font: fontOptions}},
        { header: 'Infos', key: 'infos', width: 40, style: { font: fontOptions}},
      ];
      const border = {
        top: {style:'thin', color: {argb:'FFAAAAAA'}},
        left: {style:'thin', color: {argb:'FFAAAAAA'}},
        bottom: {style:'thin', color: {argb:'FFAAAAAA'}},
        right: {style:'thin', color: {argb:'FFAAAAAA'}}
      };
      ws.columns = columns;
      
      const rowOffset = 4;
      ws.duplicateRow(1, 3, true);
      ws.getRow(1).values = [`Endreinigungsliste ${this.weekdays[DateTime.fromFormat(name, 'dd.LL.yy').weekday] ? this.weekdays[DateTime.fromFormat(name, 'dd.LL.yy').weekday] + ', ' : ''}${name}`];
      ws.mergeCells('A1:P1');
      ws.getRow(2).values = [''];
      // ws.getCell('A2').value = `Endreinigungsliste für: ${this.weekdays[DateTime.fromJSDate(this.dateRange.start).weekday]} bis ${this.weekdays[DateTime.fromJSDate(this.dateRange.end).weekday]}   ${this.formatDate(this.dateRange.start)} - ${this.formatDate(this.dateRange.end)}`;
      ws.getCell('P2').value = `Erstellt am: ${this.formatDateTime(new Date())} Uhr`;
      ws.getCell('P2').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getRow(3).values = ['Nr', 'W', 'Abreise', 'Code', 'Zi', '', '', '', '', '', '', '', '', '', '', 'Infos'];
      ws.getCell('F3').value = 'Abreise'
      ws.getCell('L3').value = 'Anreise'
      ws.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFe9ffe3' }}
      ws.pageSetup.printTitlesColumn = 'A:P';
      ws.pageSetup.printTitlesRow = '1:4';

      // Here we add the data
      let endRow = 0;
      for (let i = 0; i < values.length; i+= 1) {
        const a = values[i];
        endRow = i + rowOffset + 3;
        ws.insertRow(i+rowOffset+1, [
          i+1,
          a.isChange ? 'W' : '',
          this.formatDate(a.endDate),
          a.rentObject.code,
          a.rentObject.rooms,
          this.getCountFromBookingExtraCode(a.bookingItems, 'Bettwäsche'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Handtuchset'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Kinderreisebett'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Kinderhochstuhl'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Haustier'),
          '',
          a.nextBooking && a.nextBooking[0] && a.isChange ?
          this.getCountFromBookingExtraCode(a.nextBooking[0].bookingItems, 'Bettwäsche') : '',
          a.nextBooking && a.nextBooking[0] && a.isChange ?
          this.getCountFromBookingExtraCode(a.nextBooking[0].bookingItems, 'Handtuchset') : '',
          a.nextBooking && a.nextBooking[0] && a.isChange ?
          this.getCountFromBookingExtraCode(a.nextBooking[0].bookingItems, 'Kinderreisebett') : '',
          a.nextBooking && a.nextBooking[0] && a.isChange ?
          this.getCountFromBookingExtraCode(a.nextBooking[0].bookingItems, 'Kinderhochstuhl') : '',
          a.cleaningInformation ? a.cleaningInformation : '',
        ]);
      }

      // Custom Color Styles
      ws.getRow(3).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
      ws.getColumn('bw').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('newbw').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('isChange').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('ht').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('kb').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('kh').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('newht').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('newkb').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('newkh').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('infos').font = { ...fontOptions, bold: false, color: { argb: 'FFFF0000' } };

      ws.getRow(1).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' }, size: 24 };
      ws.getRow(2).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
      ws.getRow(3).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };

      ws.getCell('F4').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getCell('G4').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getCell('H4').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getCell('I4').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getCell('L4').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getCell('M4').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getCell('N4').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getCell('O4').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };

      ws.mergeCells('A3:A4');
      ws.mergeCells('B3:B4');
      ws.mergeCells('C3:C4');
      ws.mergeCells('D3:D4');
      ws.mergeCells('E3:E4');
      ws.mergeCells('F3:J3');
      ws.mergeCells('K3:K4');
      ws.mergeCells('L3:O3');
      ws.mergeCells('P3:P4');

      // Here we align everything and calculate row height
      ws.eachRow(function (row, rowNr) {
        if (rowNr <= 2) return;
        let maxHeight = 0;
        row.eachCell(function (cell) {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = border;
            if (cell._column._key === "space") {
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFd5d5d5' }};
            }
            if (!cell.value) return;
            let maxHeightTemp = cell.value.toString().split('\n').length * 12;
            if (maxHeight < maxHeightTemp) maxHeight = maxHeightTemp;
        });
        if (rowNr >= 4) {
          row.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          row.height = maxHeight < 36 ? 36 : maxHeight;
        }
      });

      // Unterschriften werden für die erste Seite benötigt
      if (ws.name === "Alle Reinigungen") {
        ws.insertRow(endRow, [
          "Schlüssel erhalten:"
        ]);
        ws.getCell(`L${endRow}`).value = "Lager verschlossen:";
        ws.insertRow(endRow + 1, [
          "Meldung an:"
        ]);
        ws.mergeCells(`A${endRow}:K${endRow}`);
        ws.mergeCells(`L${endRow}:P${endRow}`);
        ws.mergeCells(`A${endRow + 1}:P${endRow + 1}`);
        ws.getCell(`A${endRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFf8fff7' }}
        ws.getCell(`L${endRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFf8fff7' }}
        ws.getCell(`A${endRow + 1}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFf8fff7' }}
        ws.getCell(`A${endRow}`).border = border;
        ws.getCell(`L${endRow}`).border = border;
        ws.getCell(`A${endRow + 1}`).border = border;
        ws.getRow(endRow).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
        ws.getRow(endRow + 1).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
        ws.getRow(endRow).height = 25;
        ws.getRow(endRow + 1).height = 25;
      }

      // Custom Alignment Styles
      ws.getColumn('infos').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(4).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(endRow).alignment = { vertical: 'middle', horizontal: 'left' };
      ws.getRow(endRow + 1).alignment = { vertical: 'middle', horizontal: 'left' };
      
      // ws.autoFilter = `A$${rowOffset}:R${rowOffset+values.length}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-text {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.extra-table {
  font-size: 0.8rem;
  td {
    padding: 0;
  }
}
</style>